import React from 'react';
import useViewportWidth from 'hooks/useViewportWidth';

const withViewportWidth = (Component) => {
	const WithViewportWidth = (props) => {
		const { viewportWidth, breakpoint, handleResize } = useViewportWidth();

		return (
			<Component
				{...props}
				viewportWidth={viewportWidth}
				breakpoint={breakpoint}
				handleResize={handleResize}
			/>
		);
	};
	WithViewportWidth.displayName = `withViewportWidth(${Component.displayName || Component.name || 'Component'})`;
	return WithViewportWidth;
};

export default withViewportWidth;
